/**
 * Receiving Module Manifest
 *
 * Replaces the two "shortcut" combos that used to be per-user preferences
 * (`invoicePromoteAdvanceToStockPref`, `receivingStockEntryCheckActionPref`) with
 * module parameters — org-wide behaviour, not a per-user toggle confusing the
 * operator. The key 'receiving' matches Module.actionProperties.redirectTo.
 *
 * `userSteps` (v2) is the per-user UI cut of advance row-actions — assignment,
 * not preference (request 0225).
 */
export const RECEIVING_STEP_OPTIONS = [
    { value: 'promote', label: 'Conciliar e efetivar' },
    { value: 'stock-entry', label: 'Entrada no estoque' },
    { value: 'request-check', label: 'Solicitar conferência' },
    { value: 'mark-checked', label: 'Marcar como conferida' },
    { value: 'accept-divergence', label: 'Aceitar divergência' },
    { value: 'generate-volumes', label: 'Gerar volumes' },
    { value: 'print-labels', label: 'Imprimir etiquetas' },
];
export const RECEIVING_ALL_STEPS = RECEIVING_STEP_OPTIONS.map((o) => o.value);
const STOCK_ENTRY_CHECK_OPTIONS = [
    { value: 'none', label: 'Nenhuma' },
    { value: 'request', label: 'Solicitar conferência' },
    { value: 'mark-checked', label: 'Marcar como conferida' },
];
export const receivingManifest = {
    key: 'receiving',
    version: 4,
    name: 'Recebimento',
    parameters: [
        {
            key: 'advanceToStockEntryAfterPromote',
            label: 'Avançar para entrada em estoque após conciliar',
            type: 'boolean',
            scope: 'module+org',
            default: false,
        },
        {
            key: 'autoConfirmStockEntry',
            label: 'Confirmar a entrada em estoque automaticamente quando não houver pendência',
            type: 'boolean',
            scope: 'module+org',
            default: false,
        },
        {
            key: 'stockEntryCheckAction',
            label: 'Ação ao confirmar a entrada em estoque',
            type: 'enum',
            scope: 'module+org',
            options: STOCK_ENTRY_CHECK_OPTIONS,
            default: 'none',
        },
        {
            key: 'advanceToGenerateVolumesAfterChecked',
            label: 'Avançar para geração de volumes após conferir',
            type: 'boolean',
            scope: 'module+org',
            default: false,
        },
        {
            key: 'advanceToLabelPrintAfterVolumes',
            label: 'Avançar para impressão de etiquetas após gerar volumes',
            type: 'boolean',
            scope: 'module+org',
            default: false,
        },
        {
            key: 'closeLabelPrintAfterPrint',
            label: 'Fechar a impressão de etiquetas após imprimir',
            type: 'boolean',
            scope: 'module+org',
            default: false,
        },
        {
            key: 'userSteps',
            label: 'Passos sob responsabilidade do usuário',
            type: 'multi-enum',
            scope: 'module+org+user',
            options: [...RECEIVING_STEP_OPTIONS],
            default: [...RECEIVING_ALL_STEPS],
        },
    ],
};
//# sourceMappingURL=receiving.manifest.js.map